import {SimpleReelModelSymbolData} from "../../core/reel/simplereel/SimpleReelModel";
import {TheCageSymbol, TheCageSymbolStates} from "../reels/TheCageSymbol";
import {TheCage} from "../TheCage";


/**
 * Created by jonas on 2021-02-19.
 */

export class SymbolUtils {


    public static getAllSymbolsWithState(state:TheCageSymbolStates):SimpleReelModelSymbolData[] {
        const coords = TheCage.model.winData.matrix.getAllCoordinatesForValue(state);
        const symbols = [];
        for (let coordinate of coords) {
            symbols.push(TheCage.reelView.getVisibleSymbolDataAt(coordinate.column, coordinate.row));
        }
        return symbols;
    }

    public static getAllSymbolsWithStateByReel(state:TheCageSymbolStates):SimpleReelModelSymbolData[][] {
        const coords = TheCage.model.winData.matrix.getAllCoordinatesForValue(state);
        const reel:SimpleReelModelSymbolData[][] = [[], [], [], [], [], [], []];
        for (let coordinate of coords) {
            reel[coordinate.column].push(TheCage.reelView.getVisibleSymbolDataAt(coordinate.column, coordinate.row));
        }
        return reel;
    }

    public static getAllFreespinSymbolsWithState(state:TheCageSymbolStates):SimpleReelModelSymbolData[] {
        const coords = TheCage.model.winData.matrix.getAllCoordinatesForValue(state);
        const symbols = [];
        for (let coordinate of coords) {
            symbols.push(TheCage.freeSpinReelView.getVisibleSymbolDataAt(coordinate.column, coordinate.row));
        }
        return symbols;
    }

    public static getAllFreespinSymbolsWithStateByReel(state:TheCageSymbolStates):SimpleReelModelSymbolData[][] {
        const coords = TheCage.model.winData.matrix.getAllCoordinatesForValue(state);
        const reel:SimpleReelModelSymbolData[][] = [[], [], [], [], [], [], [], [], []];
        for (let coordinate of coords) {
            reel[coordinate.column].push(TheCage.freeSpinReelView.getVisibleSymbolDataAt(coordinate.column, coordinate.row));
        }
        return reel;
    }

    public static getSymbolStateAnimations(symbols:SimpleReelModelSymbolData[], state:TheCageSymbolStates):gsap.core.Timeline[] {
        const result:gsap.core.Timeline[] = [];
        for(let sym of symbols) {
            result.push((<TheCageSymbol>sym.positionable).getStateAnimation(state));
        }
        return result;
    }

    /*    public static getSymbolShakeAnimations(symbols:SimpleReelModelSymbolData[], duration:number):gsap.core.Timeline {
            const result:gsap.core.Timeline = gsap.timeline();
            for(let sym of symbols) {
                result.add((<OctagonSymbol>sym.positionable).getShakeAnimation(duration), 0);
            }
            return result;
        }*/

}